
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Luxurytempotraveller() {



  const cardData =
  {
    keyword: ' Luxury Tempo Traveller on Rent in Pune',
    heading: 'Vaishnavi Travels: Luxury Tempo Traveller on Rent in Pune',
    headingDescription: 'Vaishnavi Travels offers premium Luxury Tempo Traveller on Rent in Pune, ideal for weddings, family functions, corporate outings, school trips, and outstation tours. Our luxury Tempo Travellers are equipped with plush push-back seats, modern interiors, LED lighting, strong air-conditioning, and ample luggage space, ensuring a stylish and comfortable travel experience. With professional chauffeurs, punctual pickups, and flexible booking options, we make group travel smooth and hassle-free. Whether it’s a religious yatra, weekend picnic, or long-distance holiday, Vaishnavi Travels guarantees safe, reliable, and elegant luxury Tempo Traveller rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s grand fort palace and one of the city’s most iconic landmarks. Once the political seat of the Maratha Empire, its mighty gates, gardens, and ancient ruins narrate stories of power and valor. Though destroyed partially by fire in 1828, the fort still attracts thousands daily. The evening light-and-sound show revives tales of Bajirao and Mastani with grandeur. Its courtyards, fountains, and corridors are filled with historic charm. Shaniwar Wada is Pune’s timeless cultural crown jewel."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a monument of national importance tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, the palace serves as a museum housing Gandhi’s personal belongings, photos, and letters. Its sprawling gardens and Italian arches add serene charm. Students, historians, and tourists visit to pay homage to the Father of the Nation. Aga Khan Palace is Pune’s inspirational symbol of sacrifice and heritage."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Perched on a hill, it offers panoramic views of the Sahyadris and thrilling trekking routes. Visitors explore its bastions, memorials, and temples that echo Maratha bravery. During monsoon, misty weather and waterfalls make the experience enchanting. Local stalls serve rustic pithla-bhakri to trekkers and pilgrims. Sinhagad Fort is Pune’s blend of history, adventure, and scenic charm."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established more than 125 years ago, it houses a grand idol adorned with gold and ornaments. During Ganesh Chaturthi, it becomes the epicenter of massive celebrations attracting lakhs of devotees. Known for its charitable and cultural contributions, it is a hub of devotion and service. The temple’s aura is spiritually uplifting for all visitors. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Featuring massive stone pillars, sanctum chambers, and a Nandi mandapa, it reflects India’s ancient craftsmanship. Despite being in the city center, it provides peace and a meditative atmosphere. Evening chants create an aura of devotion. History lovers admire its simplicity and timeless design. Pataleshwar Cave Temple is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing more than 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include musical instruments, ornaments, sculptures, and everyday antiques from across India. A highlight is the recreated Mastani Mahal, symbolizing Maratha romance and heritage. Students and tourists find it highly educational and fascinating. It preserves centuries of Indian artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of art and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage sites, offers a panoramic view of the city. At the hilltop stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Smaller shrines and a museum enrich the visit. Pilgrims climb 103 steps to reach the temple, blending devotion with scenic beauty. Sunrise and sunset views here are captivating. Parvati Hill is Pune’s sacred and serene retreat above the city."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global center of wellness and spirituality. Spread across lush gardens, it attracts seekers and tourists from around the world. Meditation sessions, yoga practices, and workshops on personal growth are held daily. Its Zen gardens and tranquil meditation halls create a peaceful experience. Beyond spirituality, it offers rejuvenation and relaxation for modern lifestyles. Osho Ashram is Pune’s international hub of mindfulness and healing."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, manicured lawns, and seasonal flowers. Families enjoy picnics, photography, and peaceful walks here. The garden also symbolizes Indo-Japanese cultural friendship. Its year-round greenery makes it a favorite among nature lovers. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular outskirt retreat near Pune. It supplies water to the city while offering scenic backdrops of hills and flowing waters. Monsoon transforms the dam into a spectacular sight with overflowing water. Families enjoy roadside snacks like roasted corn and tea while relaxing by the banks. It also serves as the starting point for Sinhagad Fort trips. Khadakwasla Dam is Pune’s refreshing natural escape."
  }
],


    "services": [
    {
      "name": "Luxury Tempo Traveller Pune",
      "description": "Travel in style and comfort with our Luxury Tempo Traveller service in Pune. Equipped with plush recliner seats, high-quality interiors, and modern amenities, these vehicles are perfect for group travel, family outings, and corporate events. The spacious design ensures ample legroom and luggage space, while advanced air conditioning and entertainment systems keep passengers refreshed and entertained on both short and long journeys."
    },
    {
      "name": "Premium Tempo Hire Pune",
      "description": "Experience premium travel with our Tempo Traveller rentals offering superior comfort and convenience. Ideal for VIP guests, weddings, and executive travel, these vehicles come with professional drivers, on-board refreshments, and personalized services. Our premium tempos ensure punctuality, safety, and a smooth ride, making your journey memorable and hassle-free."
    },
    {
      "name": "AC Tempo Traveller Rental",
      "description": "Beat the heat with our fully air-conditioned Tempo Traveller rental service in Pune. Perfect for summer trips, corporate outings, and leisure travel, these vehicles feature powerful AC units, comfortable seating, and noise insulation. Designed to accommodate 13, 17, and 20 passengers, they offer flexibility for small to large groups while maintaining a luxurious travel experience."
    },
    {
      "name": "13/17/20 Seater Luxury Tempo Pune",
      "description": "Choose from our fleet of 13, 17, or 20 seater luxury Tempo Travellers tailored to your group size and travel needs. Whether it's a family vacation, corporate event, or wedding transport, these tempos provide ample space, ergonomic seating, and modern safety features. Equipped with multimedia systems, charging ports, and elegant interiors, they guarantee a comfortable and enjoyable ride for all passengers."
    },
    {
      "name": "Outstation Tempo Traveller Hire",
      "description": "Plan your outstation trips effortlessly with our Tempo Traveller hire service from Pune. Whether you are visiting hill stations, pilgrimage spots, or tourist destinations, our vehicles offer reliable performance, spacious interiors, and experienced drivers knowledgeable about long routes. Fuel and toll charges are transparently managed, ensuring a stress-free travel experience for groups large and small."
    },
    {
      "name": "Tempo Traveller with Recliner Seats Pune",
      "description": "Relax and rejuvenate during your journey with Tempo Travellers equipped with premium recliner seats in Pune. Ideal for long-distance travel and corporate tours, these vehicles provide maximum comfort with adjustable seating positions, armrests, and footrests. The enhanced seating reduces fatigue and makes your trip pleasant and refreshing from start to finish."
    },
    {
      "name": "Family Trip Tempo Hire Pune",
      "description": "Make family outings more enjoyable with our Tempo Traveller rentals designed for group travel within and outside Pune. Spacious cabins, safety features like seat belts, and child-friendly amenities ensure a safe and fun trip for families. Our drivers are courteous and punctual, providing door-to-door service and assistance throughout your journey."
    },
    {
      "name": "Corporate Luxury Tempo Pune",
      "description": "Elevate your corporate travel with our luxury Tempo Traveller service in Pune. Perfect for business meetings, conferences, and client transport, these vehicles come with Wi-Fi, charging ports, and comfortable seating. Our professional drivers adhere to schedules strictly, ensuring timely arrivals and departures, helping your team travel efficiently and comfortably."
    },
    {
      "name": "Wedding Tempo Traveller Rental",
      "description": "Celebrate your special day with our wedding Tempo Traveller rentals in Pune. Offering elegant interiors and smooth rides, our tempos are ideal for transporting wedding parties, guests, and VIPs. Customized decoration options and flexible rental packages make it easy to add a touch of luxury and convenience to your wedding logistics."
    },
    {
      "name": "VIP Tempo Van Pune",
      "description": "Travel like a VIP with our exclusive Tempo Van services in Pune. Equipped with luxury interiors, privacy curtains, entertainment systems, and refreshments, these vans cater to high-profile clients and special events. Our drivers are trained for discretion and professionalism, providing a premium travel experience for all occasions."
    },
    {
      "name": "Group Tour Tempo Hire Pune",
      "description": "Plan your group tours effortlessly with our Tempo Traveller hire service in Pune. Suitable for school trips, religious tours, corporate outings, and social events, our tempos offer comfortable seating, ample luggage space, and onboard amenities. We provide flexible booking options, group discounts, and professional drivers to make your trip smooth and enjoyable."
    },
    {
      "name": "Online Luxury Tempo Booking",
      "description": "Book your luxury Tempo Traveller online with ease and convenience. Our digital platform allows you to choose your vehicle type, specify travel dates, and customize your trip requirements. Enjoy instant confirmations, transparent pricing, and 24/7 customer support, ensuring a hassle-free booking experience for all your travel needs in Pune and beyond."
    },
    {
      "name": "Tempo Traveller for Long Routes Pune",
      "description": "Take on long routes comfortably with our Tempo Traveller rentals designed for endurance and passenger comfort. Whether it’s interstate travel, pilgrimage tours, or corporate trips, our tempos feature robust suspension, powerful AC, and spacious seating arrangements. Our drivers are experienced with long-distance routes, ensuring safety and timely arrivals."
    }
  ],
  "tableData": [
    ["Luxury Tempo Traveller Pune", "Premium Tempo Hire Pune"],
    ["AC Tempo Traveller Rental", "13/17/20 Seater Luxury Tempo Pune"],
    ["Outstation Tempo Traveller Hire", "Tempo Traveller with Recliner Seats Pune"],
    ["Family Trip Tempo Hire Pune", "Corporate Luxury Tempo Pune"],
    ["Wedding Tempo Traveller Rental", "VIP Tempo Van Pune"],
    ["Group Tour Tempo Hire Pune", "Online Luxury Tempo Booking"],
    ["Tempo Traveller for Long Routes Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Luxury Tempo Traveller on Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers premium luxury Tempo Traveller rentals in Pune, perfect for comfortable and stylish group travel, corporate events, and special occasions."
  },
  {
    "WhyChooseheading": "Spacious and Luxurious Seating",
    "WhyChoosedescription": "Our luxury Tempo Travellers come with plush leather seats, ample legroom, air conditioning, and modern amenities for a premium travel experience."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each vehicle is regularly serviced and thoroughly cleaned to ensure safety, hygiene, and comfort during your journey."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our professional drivers provide safe, punctual, and courteous service, familiar with Pune routes and nearby destinations."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rental options tailored to your travel needs and group size."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our all-inclusive pricing covers fuel, tolls, driver allowance, and taxes for a hassle-free booking experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Events, Family Trips, and Group Outings",
    "WhyChoosedescription": "Perfect for business trips, weddings, sightseeing tours, and other special occasions in and around Pune."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, itinerary changes, and travel inquiries."
  }
]


















  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer luxury Tempo Traveller on rent in Pune?',
      answer: 'Yes, Vaishnavi Travels provides luxury Tempo Traveller rentals in Pune, perfect for corporate events, family outings, weddings, and group travel requiring premium comfort.',
    },
    {
      question: 'What luxury features are available in the Tempo Traveller offered by Vaishnavi Travels in Pune?',
      answer: 'Our luxury Tempo Travellers come equipped with plush leather seats, advanced air-conditioning, spacious interiors, entertainment systems, ample legroom, and superior suspension for a smooth and comfortable ride.',
    },
    {
      question: 'Are the luxury Tempo Travellers well-maintained and driven by professional chauffeurs?',
      answer: 'Absolutely! All vehicles are regularly serviced and maintained to the highest standards. Our experienced drivers are professional, courteous, and ensure a safe and timely journey.',
    },
    {
      question: 'What is the rental cost for luxury Tempo Traveller in Pune?',
      answer: 'Rental costs typically start from ₹6,000 for half-day rentals, varying based on duration, distance, and any additional services requested.',
    },
    {
      question: 'Can I book luxury Tempo Traveller for outstation trips from Pune?',
      answer: 'Yes, Vaishnavi Travels offers luxury Tempo Traveller rentals for local and outstation trips with customizable packages tailored to your needs.',
    },
    {
      question: 'How early should I book a luxury Tempo Traveller rental in Pune?',
      answer: 'It is advisable to book at least 3-4 days in advance, especially during peak seasons and special events to ensure availability.',
    },
    {
      question: 'Is flexible pickup and drop-off available for luxury Tempo Traveller rentals in Pune?',
      answer: 'Yes, flexible pickup and drop locations within Pune and nearby areas are available to accommodate your travel plans.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Rajesh Kulkarni",
    position: "Corporate Client",
    feedback:
      "We rented a luxury Tempo Traveller from Vaishnavi Travels for our corporate event in Pune. The vehicle was very comfortable, spacious, and the driver was highly professional.",
    rating: 5,
  },
  {
    name: "Ms. Sneha Patil",
    position: "Event Organizer",
    feedback:
      "Vaishnavi Travels provided excellent service with their luxury Tempo Traveller rental. The vehicle was well-maintained, and the entire experience was seamless and enjoyable.",
    rating: 5,
    style: "style-2",
  }
];






































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Tempo Traveller on Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/luxury-tempo-traveller-pune.jpg",
  "description": "Rent premium luxury Tempo Travellers in Pune with AC and recliner seats. Available in 13, 17, and 20 seater configurations, ideal for family trips, corporate events, weddings, and long route travel.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "270"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/luxury-tempo-traveller-rental-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Luxury Tempo Traveller on Rent in Pune | Premium AC Tempo Traveller Hire</title>
  <meta
    name="description"
    content="Rent premium luxury Tempo Travellers in Pune with AC and recliner seats. Available in 13, 17, and 20 seater configurations, ideal for family trips, corporate events, weddings, and long route travel."
  />
  <meta
    name="keywords"
    content="Luxury Tempo Traveller Pune, Premium Tempo Hire Pune, AC Tempo Traveller Rental, 13/17/20 Seater Luxury Tempo Pune, Outstation Tempo Traveller Hire, Tempo Traveller with Recliner Seats Pune, Family Trip Tempo Hire Pune, Corporate Luxury Tempo Pune, Wedding Tempo Traveller Rental, VIP Tempo Van Pune, Group Tour Tempo Hire Pune, Online Luxury Tempo Booking, Tempo Traveller for Long Routes Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/49.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurytempotraveller;